<script>

import CardsEventos from './CardsEventos.vue';
import Contrato from '@/services/contrato';
import dayjs from 'dayjs';
import BarraAnimada from './BarraAnimada.vue';

import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
const FMT = "DD-MM-YYYY HH:mm";

export default {
  props: {
    empresa: {
      type: String,
      required: true,
    },
    telefone: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cardColor: "#2c3e50",
      cardRows: [],
    };
  },
  name: 'App',
  components: {
    CardsEventos, BarraAnimada
  },
  computed: {
    emAndamento() {
      const now = dayjs(); // NÃO formata: use o objeto dayjs
      return this.cardRows.filter((card) => {
        if (card.velorio === "NÃO INFORMADO") {
          // se não informou velório, considera em andamento até o sepultamento
          const sep = dayjs(card.sepultamento, FMT, true);
          return sep.isValid() && (now.isBefore(sep) || now.isSame(sep));
        }

        const velorio = dayjs(card.velorio, FMT, true);
        const sep = dayjs(card.sepultamento, FMT, true);
        if (!velorio.isValid() || !sep.isValid()) return false;

        // inclusivo nas pontas: [velório, sepultamento]
        return now.isBetween(velorio, sep, "minute", "[]");
      });
    },

    proximosEventos() {
      const now = dayjs();
      return this.cardRows.filter((card) => {
        if (card.velorio === "NÃO INFORMADO") return false;
        const velorio = dayjs(card.velorio, FMT, true);
        return velorio.isValid() && now.isBefore(velorio);
      });
    },
  },

  mounted() {
    this.lista(this.empresa);
    setInterval(() => {
      window.location.reload();
    }, 300000);
  },

  methods: {
    lista(empresa) {
      Contrato.lista(empresa)
        .then(response => {
          if (response.status === 200) {
            this.cardRows = response.data;
          }
        })
        .catch(error => {
          console.error('Erro na requisição', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
};
</script>

<template>

  <div class="table-container">
    <div class="table-content" v-if="emAndamento.length === 0 && proximosEventos.length > 0">
      <div class="title">
        <h1>Próximos eventos</h1>
      </div>
      <div class="cards-andamento">
        <div class="cards-andamento">
          <CardsEventos v-for="card in proximosEventos" :key="card.id" :cardColor="cardColor" :nome="card.falecido"
            :capela="card.capela" :velorio="card.velorio" :sepultamento="card.sepultamento" :cemiterio="card.cemiterio"
            :falecimento="card.falecimento" :nascimento="card.nascimento" :empresaVelorio="card.empresa" />
        </div>
      </div>
    </div>
    <div class="table-content" v-else>
      <div class="title">
        <h1>Em andamento</h1>
      </div>
      <div class="cards-andamento">
        <p v-if="emAndamento.length === 0" class="title-content">
          Sem previsões
        </p>

        <CardsEventos v-else v-for="card in emAndamento" :key="card.id" :cardColor="cardColor" :nome="card.falecido"
          :capela="card.capela" :velorio="card.velorio" :sepultamento="card.sepultamento" :cemiterio="card.cemiterio"
          :falecimento="card.falecimento" :nascimento="card.nascimento" :empresaVelorio="card.empresa" />
      </div>
    </div>
    <div class="footer-content">
      <div class="titleproximo">
        <div class="table-empresa">
          <h1 v-if="emAndamento.length > 0">Próximos Velórios</h1>
          <h1 v-else-if="empresa === 'Todos'">Grupo Parque das Flores</h1>
          <h1 v-else>{{ empresa }}</h1>
        </div>

        <div v-if="empresa != 'Grupo Parque das Flores'" class="qrcode">
          <p class="table-contato">Fale conosco pelo telefone ou WhatsApp: {{ telefone }}</p>
          <img v-if="empresa === 'Previda'" src="../../public/qrcode/previda.png" alt="Logo" />
          <img v-else-if="empresa === 'Parque das Flores'" src="../../public/qrcode/parquedasflores.png" alt="Logo" />
          <img v-else-if="empresa === 'Cemiterio Previda' || 'Parque do Agreste'" src="../../public/qrcode/interior.png"
            alt="Logo" />
          <img v-else-if="empresa === 'Memorial Parque Maceio'" src="../../public/qrcode/memorial.png" alt="Logo" />
        </div>
      </div>

      <div class="infoproximo">
        <BarraAnimada v-if="emAndamento.length > 0" :events="proximosEventos" />
        <BarraAnimada v-else />
      </div>
    </div>

  </div>

</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

* {
  margin: 0;
}

.table-container {
  margin-top: 14vh;
}

.cards-andamento {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
  min-height: 70vh;
  margin-bottom: 22vh;
}

.footer-content {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #cdd3e6;
}

.title {
  font-size: 26px;
}

.titleproximo {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  text-align: left;
  font-size: 1rem;
}

.titleproximo h1 {
  margin-left: 1rem;
}

.infoproximo {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-content: flex-start;
  margin-top: 1rem;

}

.title-content {
  font-size: 20px;
}

.qrcode {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-right: 10px;
  height: 100px;
  gap: 1rem;
}

.qrcode img {
  height: 100%;
}

.qrcode p {
  font-size: 20px;
}



@media screen and (max-width: 815px) {
  .title h1 {
    font-size: 2.6rem;
  }

  .table-empresa h1 {
    font-size: 1.6rem;
  }

  .table-contato {
    display: none;
  }
}
</style>
